module.exports = __webpack_public_path__ + "img/dzl.e20ef4a.png";